module.exports = __webpack_public_path__ + "a2581bd2366030a12fb428f7035bc94d.svg";